import { jsx } from 'react/jsx-runtime';
import { colors } from '@flex-design-system/fx-colors';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { titleBackButton, titleBackButtonClickable } from './backButton.vanilla.mjs';
import { useTitleContext } from './context.mjs';

const TITLE_BACK_BUTTON_NAME = "TitleBackButton";
const BackButton = forwardRef(({ className: classNameFromProps, type = "button", ...props }, ref) => {
  const { size } = useTitleContext(TITLE_BACK_BUTTON_NAME);
  const commonProps = {
    ...props,
    className: classNames(
      titleBackButton({ size }),
      !props.disabled && titleBackButtonClickable,
      classNameFromProps
    ),
    ref,
    size,
    type,
    "aria-label": "back button"
  };
  if ("children" in props) {
    return /* @__PURE__ */ jsx(Primitive.button, { ...commonProps, children: props.children({ backButtonIcon }) });
  }
  return /* @__PURE__ */ jsx(Primitive.button, { ...commonProps, children: backButtonIcon });
});
const backButtonIcon = /* @__PURE__ */ jsx(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.3106 6L19 7.62621L12.3787 14L19 20.3738L17.3106 22L9 14L17.3106 6Z",
        fill: colors.grayDark
      }
    )
  }
);

export { BackButton as default };
//# sourceMappingURL=BackButton.mjs.map
